var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 16 20",
        fill: "currentColor",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M8 0.157715L0 3.15771V9.24771C0 14.2977 3.41 19.0077 8 20.1577C12.59 19.0077 16 14.2977 16 9.24771V3.15771L8 0.157715ZM6.94 13.6977L3.4 10.1577L4.81 8.74771L6.93 10.8677L11.17 6.62772L12.58 8.03771L6.94 13.6977Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }